import { css } from '@emotion/core';
import { MediaQueries } from '../../../styles/Grid';

export const containerMarginCss = css({
  margin: '64px 0',
  [MediaQueries.mdAndUp]: {
    margin: '96px 0',
  },
});

export const containerPaddingCss = css({
  padding: '64px 0',
  [MediaQueries.mdAndUp]: {
    padding: '96px 0',
  },
});

export const showMoreContainerCss = css({
  marginTop: 17,
  [MediaQueries.mdAndUp]: {
    display: 'none',
  },
});

export const seeLessMoreCss = css({
  borderRadius: '8px',
  outline: '0px',
  border: '#D7D7D7 solid 1px',
});
